module.exports = __webpack_public_path__ + "img/medical_staff.2eb8fb45.svg";